import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../config/api.config';
import { activeLanguage } from '../utils/utils';
import { IContent, IPromotionsContent } from '../interfaces/content';
import {
  IDepartment,
  ILossBsos,
  INews,
  INewsDetail,
  IPage,
  IPromotionsDetail,
} from '../interfaces/pages';

const getContent = createAsyncThunk<IContent>(
  'getContent',
  async (_data, thunkAPI) => {
    // const { dispatch } = thunkAPI;
    try {
      const res = await API.get(`/site/content/home`, {
        params: {
          culture: activeLanguage(),
        },
      });
      // dispatch(setContent(res.data));
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getPage = createAsyncThunk<IPage, string>(
  'getPage',
  async (data, thunkAPI) => {
    try {
      const res = await API.get(`/site/content/page${data}`, {
        params: {
          culture: activeLanguage(),
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getDepartment = createAsyncThunk<IDepartment, string>(
  'getDepartment',
  async (data, thunkAPI) => {
    try {
      const res = await API.get(`/site/content/department${data}`, {
        params: {
          culture: activeLanguage(),
        },
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getNews = createAsyncThunk<INews, number>(
  'getNews',
  async (data: number, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/news/${activeLanguage()}/${data}`,
        {}
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getNewsDetail = createAsyncThunk<INewsDetail, string>(
  'getNewsDetail',
  async (id, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/news/detail/${id}/${activeLanguage()}`
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getLossBsos = createAsyncThunk<ILossBsos, number>(
  'getLossBsos',
  async (data: number, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/loss-bsos/${activeLanguage()}/${data}`,
        {}
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getLossBsosDetail = createAsyncThunk<INewsDetail, string>(
  'getLossBsosDetail',
  async (id, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/loss-bsos/detail/${id}/${activeLanguage()}`
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getPromotions = createAsyncThunk<IPromotionsContent[]>(
  'getPromotions',
  async (_data, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/promotions/${activeLanguage()}`,
        {}
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const getPromotionsDetail = createAsyncThunk<IPromotionsDetail, string>(
  'getPromotionsDetail',
  async (id, thunkAPI) => {
    try {
      const res = await API.get(
        `/site/content/promotions/detail/${id}/${activeLanguage()}`
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export {
  getContent,
  getPage,
  getDepartment,
  getNews,
  getNewsDetail,
  getLossBsos,
  getLossBsosDetail,
  getPromotions,
  getPromotionsDetail,
};
